import { __assign, __makeTemplateObject } from "tslib";
import * as React from 'react';
import { extendTheme, ChakraProvider } from '@chakra-ui/react';
import { Global, css } from '@emotion/react';
var defaultProject = {
  title: '',
  productType: '',
  email: ''
};
export var ProjectContext = /*#__PURE__*/React.createContext(defaultProject);
var defaultTheme = {
  fonts: {
    body: 'Anakotmai, system-ui, sans-serif',
    heading: 'Anakotmai, Georgia, serif',
    mono: 'Anakotmai, Menlo, monospace'
  },
  colors: {
    brand: {
      50: '#d8f3ff',
      100: '#abddff',
      200: '#7bcaff',
      300: '#49bbff',
      400: '#1aafff',
      500: '#009ee6',
      600: '#006fb4',
      700: '#004782',
      800: '#002551',
      900: '#000b21'
    }
  }
};
export var PaymentProvider = function PaymentProvider(_a) {
  var theme = _a.theme,
      project = _a.project,
      children = _a.children;
  var paymentTheme = extendTheme(__assign(__assign({}, theme), {
    layerStyles: __assign({
      actionable: {
        opacity: 1,
        cursor: 'pointer',
        transition: 'opacity 150ms',
        _hover: {
          opacity: 0.7
        },
        _focus: {
          opacity: 0.65
        },
        _active: {
          opacity: 0.5
        }
      }
    }, theme.layerStyles),
    fonts: __assign(__assign({}, defaultTheme.fonts), theme === null || theme === void 0 ? void 0 : theme.fonts),
    colors: __assign(__assign({}, defaultTheme.colors), theme === null || theme === void 0 ? void 0 : theme.colors),
    styles: {
      global: function global(props) {
        return {
          '.StripeElement': __assign(__assign(__assign({}, props.theme.components.Input.baseStyle.field), props.theme.components.Input.variants.outline(props).field), {
            borderRadius: props.theme.radii[props.theme.components.Input.sizes.md.field.borderRadius],
            padding: "0 " + props.theme.sizes[props.theme.components.Input.sizes.md.field.px],
            height: props.theme.sizes[props.theme.components.Input.sizes.md.field.h],
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            maxHeight: '100%',
            overflow: 'hidden'
          }),
          '.StripeElement > *': {
            flex: '1 1 auto',
            maxHeight: '1.3em'
          },
          '.StripeElement iframe': {
            maxHeight: '1.3em'
          },
          '.StripeElement--focus': __assign(__assign({}, props.theme.components.Input.baseStyle.field._focus), props.theme.components.Input.variants.outline(props).field._focus),
          '.StripeElement--invalid': __assign(__assign({}, props.theme.components.Input.baseStyle.field._invalid), props.theme.components.Input.variants.outline(props).field._invalid)
        };
      }
    }
  }));
  return /*#__PURE__*/React.createElement(ChakraProvider, {
    resetCSS: true,
    theme: paymentTheme
  }, /*#__PURE__*/React.createElement("div", {
    className: "dw-payment-ui"
  }, /*#__PURE__*/React.createElement(Global, {
    styles: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            .dw-payment-ui {\n              font-family: ", ";\n            }\n\n            .dw-payment-ui *:focus,\n            [id^='chakra-portal'] *:focus {\n              outline: none;\n              box-shadow: none !important;\n            }\n\n            [id^='chakra-portal'] {\n              font-family: ", ";\n            }\n          "], ["\n            .dw-payment-ui {\n              font-family: ", ";\n            }\n\n            .dw-payment-ui *:focus,\n            [id^='chakra-portal'] *:focus {\n              outline: none;\n              box-shadow: none !important;\n            }\n\n            [id^='chakra-portal'] {\n              font-family: ", ";\n            }\n          "])), paymentTheme.fonts.body, paymentTheme.fonts.body)
  }), /*#__PURE__*/React.createElement(ProjectContext.Provider, {
    value: project
  }, children)));
};
var templateObject_1;